const courses = [
  { id: 1, text: "Programação", icon: "fas fa-laptop-code" },
  //{ id: 2, text: "Ciências", icon: "fa fa-flask" },
  //{ id: 3, text: "Desenho", icon: "fas fa-palette" },
  //{ id: 4, text: "Inglês", icon: "fas fa-flag-usa" },
];

export default courses;
